var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header" }, [
      _vm.$route.path === "/accountCreate"
        ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.accountCreateHeaderText))])])
        : _vm.$route.path === "/recordMeals"
        ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.recordMealsHeaderText))])])
        : _vm.$route.path === "/history"
        ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.historyHeaderText))])])
        : _vm.$route.path === "/frailtyRiskCheck"
        ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.frailtyRiskCheckHeaderText))])])
        : _vm.$route.path === "/other"
        ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.otherHeaderText))])])
        : _vm.$route.path === "/WeeklyTable"
        ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.weeklyTableHeaderText))])])
        : _vm.$route.path === "/WaterWeeklyBar"
        ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.weeklyTableHeaderText))])])
        : _c("div", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.last_name) +
                " " +
                _vm._s(_vm.firstName) +
                "\n    "
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 